<template>
  <aha-modal
    @hide="$emit('hide')"
    title="Take over the presentation?"
    class="take-over-modal"
  >
    <p>
      Once you take over, you can:
      <ul class="ml-5">
        <li>Present</li>
        <li>Change the settings that affects this entire presentation</li>
      </ul>
    </p>
    <template #action>
      <aha-link
        @click="$emit('hide')"
      >
        <span class="font-bold">Cancel</span>
      </aha-link>
      <aha-button
        has-margin-left
        variant="primary"
        @click="$emit('takeOver')"
        :submitting="submitting"
        :disabled="submitting"
      >
        Take over
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    presenting: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
  },
}
</script>

<style lang="scss" scoped>
ul {
  list-style: disc;
}
</style>
